import { createFileRoute, redirect } from '@tanstack/react-router'
import { HTTPError } from 'ky'
import {
  bootstrapQueryOptions,
  useBootstrapQuery,
} from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import SettingsShellPage from '@/pages/settings/shell'
import OrganizationSettingsPage from '@/pages/settings/organization'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'

function SettingsOrganizationRoutePage() {
  const bootstrapQuery = useBootstrapQuery()
  const canViewOrganizationTab =
    bootstrapQuery.data?.organization?.isVisible === true

  if (bootstrapQuery.isLoading || !canViewOrganizationTab) {
    return null
  }

  return (
    <SettingsShellPage activeTab="organization">
      <OrganizationSettingsPage />
    </SettingsShellPage>
  )
}

export const Route = createFileRoute('/$lang/settings/organization')({
  beforeLoad: async ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      throw redirect({
        to: '/$lang/settings/general',
        params: { lang: params.lang },
        replace: true,
      })
    }
    requireAuthenticated(context, params)

    let bootstrap
    try {
      bootstrap = await context.queryClient.fetchQuery(bootstrapQueryOptions())
    } catch (error) {
      if (error instanceof HTTPError && error.response.status === 403) {
        throw redirect({
          to: '/$lang/pending-approval',
          params: { lang: params.lang },
          replace: true,
        })
      }
      throw error
    }

    if (bootstrap.organization?.isVisible !== true) {
      throw redirect({
        to: '/$lang/settings/billing',
        params: { lang: params.lang },
        replace: true,
      })
    }
  },
  staticData: { layout: 'main' },
  component: SettingsOrganizationRoutePage,
})
